import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChangeRequestTemplate } from '@models/change-requests/change-request-template.model';
import { Employee } from '@models/employee/employee.model';
import { FieldValueSetInterface } from '@change-requests/interfaces';

interface ValueResponse {
    data: {
        attributes: {
            values: FieldValueSetInterface;
        };
    };
}

@Injectable()
export class EmployeeFieldValueService {
    constructor(private http: HttpClient) {}

    async getFieldValues(template: ChangeRequestTemplate, subject: Employee): Promise<FieldValueSetInterface> {
        const url = `/v2/changeRequest/changeRequestTemplates/${template.id}/employees/${subject.id}`;
        const res = await this.http.get<ValueResponse>(url).toPromise();
        return res.data.attributes.values;
    }
}
